import { useEffect, useState } from "react";
import axios from "axios";

export default function ContactSection() {
  const [contacts, setContacts] = useState([]);
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

useEffect(() => {
  const fetchContacts = async () => {
    try {
      const res = await axios.get(`${API_BASE}contacts`);
      setContacts(res.data); // no need to await res.data
    } catch (error) {
      console.error("Failed to fetch contacts:", error);
    }
  };
  fetchContacts();
}, []);

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Contact Submissions</h2>
      <ul>
        {contacts.map((msg, idx) => (
          <li key={idx} className="mb-4 border-b pb-2">
            <p><strong>Name:</strong> {msg.name}</p>
            <p><strong>Email:</strong> {msg.email}</p>
            <p><strong>Message:</strong> {msg.message}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
